export default __webpack_public_path__ + "static/media/title_th_pc@2x.4004d6d2.png";